// extracted by mini-css-extract-plugin
export default {"legend":"styles_legend__k-Nj2","item":"styles_item__I8nRk","colorBox":"styles_color-box__KbHxL","itemTitle":"styles_item-title__R4YkU"};